import { MobileApp } from '../libs/proto/commUnity_pb';

export const communityAppType = MobileApp.ABRICOTIER;

export const desktopMode = 1;
export const desktopModeURL = '';
